import { extend } from 'vee-validate';
import translate from '../../common/localization/translate';

// partial taken from vee-validate v.2.2.15 until the decimal rule is back... https://github.com/logaretm/vee-validate/issues/2817
const validate = (value, { decimals = '*', separator = '.' } = {}) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every((val) => validate(val, { decimals, separator }));
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
  const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

  if (!regex.test(value)) {
    return false;
  }

  const parsedValue = parseFloat(value);

  // eslint-disable-next-line
  return parsedValue === parsedValue;
};

export default () => {
  const decimal = {
    validate,
    params: ['decimals', 'separator'],
    message: translate('common.DECIMAL_VALIDATOR'),
  };

  extend('decimal', decimal);
};
